import { db } from '@/lib/firebase/config';
import { collection, addDoc, updateDoc, deleteDoc, doc, getDocs, query, where, Timestamp } from 'firebase/firestore';
import type { PartnerOffer } from '@/components/partner/types';

const OFFERS_COLLECTION = 'partnerOffers';

export async function addPartnerOffer(offer: Omit<PartnerOffer, 'id'>): Promise<string> {
  const docRef = await addDoc(collection(db, OFFERS_COLLECTION), {
    ...offer,
    createdAt: Timestamp.fromDate(offer.createdAt),
    updatedAt: Timestamp.fromDate(offer.updatedAt),
    validUntil: Timestamp.fromDate(offer.validUntil)
  });
  return docRef.id;
}

export async function updatePartnerOffer(id: string, offer: Partial<PartnerOffer>): Promise<void> {
  const offerRef = doc(db, OFFERS_COLLECTION, id);
  const updateData = {
    ...offer,
    updatedAt: Timestamp.fromDate(new Date())
  };
  
  if (offer.validUntil) {
    updateData.validUntil = Timestamp.fromDate(offer.validUntil);
  }
  
  await updateDoc(offerRef, updateData);
}

export async function deletePartnerOffer(id: string): Promise<void> {
  const offerRef = doc(db, OFFERS_COLLECTION, id);
  await deleteDoc(offerRef);
}

export async function getPartnerOffers(partnerId?: string): Promise<PartnerOffer[]> {
  let q = collection(db, OFFERS_COLLECTION);
  
  if (partnerId) {
    q = query(q, where('partnerId', '==', partnerId));
  }
  
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      createdAt: data.createdAt.toDate(),
      updatedAt: data.updatedAt.toDate(),
      validUntil: data.validUntil.toDate()
    } as PartnerOffer;
  });
} 